//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { displayDialog, displayErrorMessage } from "store/actions/utilActions";
//#endregion
//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import useCreateRevenueReportingDialog from "./useCreateRevenueReportingDialog";
import { useRevenueReportingService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useCreateRevenueReport(
  cashReconciliationDialog: DialogProps,
  onCreateSuccess?: () => void,
  preselectedTemplateId?: string,
  periodLastDay?: Date
) {
  const dispatch = useDispatch();
  const revenueReportingEnabledForCompany = useSelector(
    (store: AppState) => store.auth.selectedCompany.revenueReportingEnabledForCompany
  );
  const revenueReportingService = useRevenueReportingService();
  const getRevenueReportingDialog = useCreateRevenueReportingDialog();

  const openReportDialog = (templates: WintSuperkollAPIModel.RevenueReportingTemplate[]) => {
    dispatch(
      displayDialog(getRevenueReportingDialog(templates, onCreateSuccess, preselectedTemplateId, periodLastDay))
    );
  };

  const fallBackToCashReconciliation = () => {
    if (revenueReportingEnabledForCompany) {
      dispatch(
        displayErrorMessage(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.RevenueReporting.NoActivePaymentMethods)
        )
      );
      return;
    }
    dispatch(displayDialog(cashReconciliationDialog));
  };

  return async function onCreateRevenueReport() {
    try {
      const templates = await revenueReportingService.getTemplates();

      if (!templates || templates.length === 0) {
        fallBackToCashReconciliation();
        return;
      }

      openReportDialog(templates);
    } catch {
      fallBackToCashReconciliation();
    }
  };
}

export default useCreateRevenueReport;
